var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47_932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41 0C18.3571 0 0 18.3571 0 41C0 63.6429 18.3571 82 41 82C63.6429 82 82 63.6429 82 41C82 18.3571 63.6429 0 41 0Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4887 37.2929L63.0403 16.8906H58.8811L43.641 34.6057L31.4689 16.8906H17.4297L35.8364 43.6789L17.4297 65.0739H21.5891L37.683 46.3662L50.5377 65.0739H64.5769L45.4876 37.2929H45.4887ZM23.0878 20.0218H29.4763L58.883 62.0851H52.4944L23.0878 20.0218Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_932"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 82,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/xIcon.b658230c8c17820a5fc19a5b418a2d72.svg";
export { ForwardRef as ReactComponent };